export default {
  labelUseScene: '使用场景',
  labelUseMethod: '使用方式',
  labelAuthArea: '授权地域',
  labelAuthTime: '授权期限',

  tryVersionText: '试听版本',
  highQualityVersionText: '高清版本',
}